var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.26795 1.14273C7.33975 0.508007 8.66025 0.508007 9.73205 1.14273L13.7679 3.53279C14.8397 4.16751 15.5 5.34052 15.5 6.60996V11.3901C15.5 12.6595 14.8397 13.8325 13.7679 14.4673L9.73205 16.8573C8.66025 17.492 7.33975 17.492 6.26795 16.8573L2.23205 14.4673C1.16025 13.8325 0.5 12.6595 0.5 11.3901V6.60996C0.5 5.34052 1.16025 4.16751 2.23205 3.53279L6.26795 1.14273Z",
    fill: "#E86346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16732 13.1667C7.16732 12.7064 7.54041 12.3333 8.00065 12.3333C8.46089 12.3333 8.83398 12.7064 8.83398 13.1667C8.83398 13.6269 8.46089 14 8.00065 14C7.54041 14 7.16732 13.6269 7.16732 13.1667Z",
    fill: "#E86346"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.2917C7.65482 11.2917 7.375 11.0119 7.375 10.6667L7.375 4.83335C7.375 4.48818 7.65482 4.20835 8 4.20835C8.34518 4.20835 8.625 4.48818 8.625 4.83335L8.625 10.6667C8.625 11.0119 8.34518 11.2917 8 11.2917Z",
    fill: "#E86346"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1a28a8bed601a3c0a7aa7f2fab138d86.svg";
export { ForwardRef as ReactComponent };